import BaseComponent from '@/components/base';
import quantityInputStyle from '@/components/quantity-input/style';
import MinusButton from '@/components/minus-button';
import plusButton from '@/components/plus-button';

export default class QuantityInputRegimen extends BaseComponent {
  render() {
    return `
    ${quantityInputStyle()}
        <div class="cart-quantity-container">
            <button class="quantity-button quantity-button-minus" name="minus" type="button" data-button="minus">
              ${MinusButton()}
            </button>
            <input
              class="quantity-input"
              data-product-handle="${this.itemHandle}"
              type="number"
              name="updates[]"
              value="${this.itemQuantity}"
              min="1"
              data-cart-quantity="1"
            >
            <button class="quantity-button quantity-button-plus" name="plus" type="button" data-button="plus">
               ${plusButton()}
            </button>
          </div>`;
  }

  async handleChangeQuantity(addQuantity) {
    const quantityInputField = this.shadowRoot.querySelector(
      '[data-cart-quantity]'
    );
    const productQuantityValue = Number(quantityInputField.value);
    const newProductQuantity = productQuantityValue + addQuantity;
    if (newProductQuantity >= 1) {
      quantityInputField.value = `${newProductQuantity}`;
      quantityInputField.setAttribute(
        'data-cart-quantity',
        `${newProductQuantity}`
      );
    }
    this.updateSubstotal();
  }

  async handleChangeQuantityInput(value) {
    const quantityInputField = this.shadowRoot.querySelector(
      '[data-cart-quantity]'
    );
    const newProductQuantity = Number(value);
    if (newProductQuantity >= 1) {
      quantityInputField.value = `${newProductQuantity}`;
      quantityInputField.setAttribute(
        'data-cart-quantity',
        `${newProductQuantity}`
      );
    } else {
      quantityInputField.value = '1';
      quantityInputField.setAttribute('data-cart-quantity', '1');
    }
    this.updateSubstotal();
  }

  updateSubstotal() {
    const allCards = document.querySelectorAll(
      '.card.product:not([data-status="disable"])'
    );
    const productsInfos = {
      totalQuantity: 0,
      totalPrice: 0,
      products: []
    };
    allCards.forEach((card) => {
      const topOptionDropdown = card.querySelector(
        '.dropdown-option.top-option'
      );
      const price = topOptionDropdown
        .querySelector('.rc-price-line .product-price')
        .getAttribute('contentraw');
      const quantityElement = topOptionDropdown.querySelector(
        'quantity-input-regimen'
      );
      const quantityInput = quantityElement.shadowRoot.querySelector('input');
      const quantity = Number(quantityInput.getAttribute('data-cart-quantity'));
      const productInfoObject = {
        price,
        quantity
      };
      productsInfos.totalQuantity += quantity;
      productsInfos.totalPrice += price * quantity;
      productsInfos.products.push(productInfoObject);
    });

    const subTotalQuantity = document.querySelector('.regimen-price-title');
    const subTotalPrice = document.querySelector('.regimen-price-number');

    if (productsInfos.totalQuantity > 0) {
      subTotalQuantity.innerHTML = `SUBTOTAL (${productsInfos.totalQuantity}):&nbsp;`;
    }
    if (productsInfos.totalPrice > 0) {
      const newPrice = Shopify.formatMoney(
        productsInfos.totalPrice,
        window.theme.moneyFormat
      );
      subTotalPrice.innerHTML = `${newPrice}`;
    }
  }

  connectedCallback() {
    this.connectStopPropagation();
    this.connectChangeQuantityButtons();
    this.connectChangeInputQuantity();
  }

  connectStopPropagation() {
    const div = this.shadowRoot.querySelector('div');
    div.addEventListener('click', (e) => e.stopPropagation());
  }

  connectChangeInputQuantity() {
    const inputQuantity = this.shadowRoot.querySelector('[data-cart-quantity]');

    inputQuantity.addEventListener('blur', (e) =>
      this.handleChangeQuantityInput(e.target.value)
    );
  }

  connectChangeQuantityButtons() {
    const buttonPlus = this.shadowRoot.querySelector('[data-button="plus"]');
    const buttonMinus = this.shadowRoot.querySelector('[data-button="minus"]');
    buttonPlus.addEventListener('click', () => this.handleChangeQuantity(+1));
    buttonMinus.addEventListener('click', () => this.handleChangeQuantity(-1));
  }

  get itemQuantity() {
    return this.getAttribute('quantity');
  }

  get itemHandle() {
    return this.getAttribute('handle');
  }
}
